import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setFootprintingDairyManureAdditive, setFootprintingDairyManureAdditiveAdmin } from "services";

import { footprintingDairyPrimaryQueryKeys, getEnvironment, invalidateAndRefecthQueries } from "utils";

import { FOOTPRINTING_DAIRY_MANURE_ADDITIVE } from "consts";

import { FootprintingDairyManureAdditivePayload } from "models";

export const useMutateFootprintingDairyManureAdditive = (
  farmId: string,
  year: number,
  payload: FootprintingDairyManureAdditivePayload,
  primaryDataId?: string
) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();
  return useMutation(
    {
      mutationKey: [FOOTPRINTING_DAIRY_MANURE_ADDITIVE, primaryDataId, isAdmin],
      mutationFn: () =>
        isAdmin ? setFootprintingDairyManureAdditiveAdmin(payload, primaryDataId) : setFootprintingDairyManureAdditive(payload, primaryDataId),
      onSuccess: async () => {
        invalidateAndRefecthQueries(queryClient, [
          [FOOTPRINTING_DAIRY_MANURE_ADDITIVE, primaryDataId, isAdmin],
          ...footprintingDairyPrimaryQueryKeys(primaryDataId ?? "", farmId, year, isAdmin),
        ]);
      },
    },
    queryClient
  );
};
